export enum StripeDirection {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
